/* ═══════════════════════════════════════════════════════════════════════════
   DN5 · site shell behaviour. Only what a "skin" should do: open/close sheets, render lists, swap copy.
   🔴 The **real actions** — pricing / add to cart / cart / market switch — always belong to the engine; not one line is re-implemented here.
      Engine contract in SHELL-CONTRACT.md. All data is read from JSON blobs emitted by Liquid;
      no menu item / country / currency / amount is hard-coded in JS.

   Naming: only one global name is taken, window.DN5Shell.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.DN5Shell) return;

  var BP = 990;                                     /* breakpoint, same as the other three dn5 pages */
  var D = document;
  function $(s, r) { return (r || D).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); }
  function isDesk() { return window.matchMedia('(min-width:' + BP + 'px)').matches; }
  function esc(x) { var d = D.createElement('div'); d.textContent = x == null ? '' : x; return d.innerHTML; }
  function json(sel) {
    var el = $(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* Open/close sheets: prefer the engine's DN2.openSheet (it owns the body scroll lock + dn2:open event);
     if the engine has not loaded yet fall back to adding the class ourselves — otherwise a first-screen tap does nothing. */
  function openSheet(el) {
    if (!el) return;
    if (window.DN2 && window.DN2.openSheet) { window.DN2.openSheet(el); return; }
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
  }
  function closeSheet(el) {
    if (!el) return;
    if (window.DN2 && window.DN2.closeSheet) { window.DN2.closeSheet(el); return; }
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
  }
  function closeAll() {
    $$('.dn5s-sheet.is-open').forEach(closeSheet);
  }

  /* ── 1 · entry delegation ──────────────────────────────────────────────── */
  /* market-aware root (e.g. /en-eu/): links built in JS keep the visitor's market, like Liquid routes.root_url */
  /* market root ('/' or '/en-eu/') from the engine's one route helper (window.dnRoute, progress-v5, ENGINE-CONTRACT §6.8) */
  function ROOT() { return window.dnRoute(''); }

  function initTriggers() {
    D.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null;
      if (!t) return;

      /* nav drawer (phone). Desktop has no such panel, so desktop is not intercepted and the <a> navigates normally. */
      if (t.closest('[data-dn5s-nav-open]')) {
        if (isDesk()) return;
        e.preventDefault(); e.stopPropagation();
        openSheet($('#dn5s-nav'));
        return;
      }
      /* search panel: opens on both widths (the proto draws the panel on both screens).
         <a href="/search"> stays as the no-JS fallback, which is why preventDefault is needed here. */
      if (t.closest('[data-dn5s-search-open]')) {
        e.preventDefault(); e.stopPropagation();
        var sp = $('#dn5s-search');
        openSheet(sp);
        setTimeout(function () { try { $('[data-dn5s-q]', sp).focus(); } catch (err) {} }, 140);
        return;
      }
      /* nav quick tiles without a configured link: open the existing support sheet (#dn2-chat via its own fab),
         same behaviour as dn4-app-v13 navToChat / navToTrack (line 785). Nothing new is sent anywhere. */
      var qc = t.closest('[data-dn5s-open-chat]');
      if (qc) {
        e.preventDefault(); e.stopPropagation();
        var topic = qc.getAttribute('data-dn5s-open-chat');
        var nv = $('#dn5s-nav'); if (nv && nv.classList.contains('is-open')) closeSheet(nv);
        setTimeout(function () {
          var fab = D.getElementById('dn2-chat-fab'); if (fab) fab.click();
          if (topic) { var tp = D.querySelector('#dn2-chat [data-ticket-topic="' + topic + '"]'); if (tp) tp.click(); }
        }, 60);
        return;
      }
      /* region / currency. The engine entry attribute [data-dn2-loc-open] is collected too,
         so any entry the black skin left behind (in other sections) also opens the dn5 panel. */
      if (t.closest('[data-dn5s-loc-open]') || t.closest('[data-dn2-loc-open]')) {
        e.preventDefault(); e.stopPropagation();
        var wasNav = $('#dn5s-nav');
        if (wasNav && wasNav.classList.contains('is-open')) {
          closeSheet(wasNav);
          setTimeout(function () { openSheet($('#dn5s-loc')); }, 60);
        } else {
          openSheet($('#dn5s-loc'));
        }
        return;
      }
      /* close: our own [data-dn5s-close], and the black skin's [data-dn2-close] (same meaning) */
      var closer = t.closest('[data-dn5s-close]');
      if (closer) {
        e.preventDefault();
        closeSheet(closer.closest('.dn5s-sheet'));
        return;
      }
      /* scrim */
      if (t.classList && t.classList.contains('dn5s-sheet__bd')) {
        closeSheet(t.closest('.dn5s-sheet'));
      }
    }, true);

    D.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  /* ── 2 · announcement carousel ─────────────────────────────────────────── */
  /* Copy and amounts are already replaced in Liquid (placeholders become plain-text amounts there);
     this only rotates + runs each message through window.dnFsText once for currency conversion.
     🔴 The carousel writes with textContent: the blob must not carry <span>, or shoppers see the literal tag. */
  function initAnnouncement() {
    var root = $('[data-dn5s-ann]');
    if (!root) return;
    var el = $('[data-dn5s-ann-msg]', root);
    /* bundle percentage tokens ({pct_2} …) are resolved by the engine (window.dn.bundle.text, ENGINE-CONTRACT §6.7);
       a message whose token cannot be resolved is dropped from the rotation instead of showing a made-up number */
    var bdHandle = root.getAttribute('data-bd-handle') || '';
    var msgs = (json('[data-dn5s-ann-msgs]') || []).map(function (m) {
      var B = window.dn && window.dn.bundle;
      return B ? B.text(m, bdHandle) : (/\{pct(_\d+|_max)?\}/.test(m) ? null : m);
    }).filter(function (m) { return m != null; });
    var mq = $('.dn5s-ann__mqwrap', root);
    var i = 0, timer = 0, fade = 0, dead = false, inView = true;
    var motion = window.DNMotionLifecycle;
    var mState = motion ? motion.snapshot()
      : { active: D.visibilityState === 'visible', reduced: false, popupCovered: false };

    function active() { return !dead && mState.active && inView; }
    function clear() {
      if (timer) clearTimeout(timer);
      if (fade) clearTimeout(fade);
      timer = fade = 0;
      if (el) el.style.opacity = '1';
    }
    function write(n) {
      if (!el || !msgs.length) return;
      i = (n + msgs.length) % msgs.length;
      el.textContent = msgs[i];
      if (window.dnFsText) window.dnFsText(el);     /* convert to the visitor's currency */
    }
    function schedule() {
      clear();
      if (!el || msgs.length < 2 || !active()) return;
      timer = setTimeout(function () {
        timer = 0;
        if (!active()) return;
        el.style.opacity = '0';
        fade = setTimeout(function () {
          fade = 0;
          if (!active()) { el.style.opacity = '1'; return; }
          write(i + 1);
          el.style.opacity = '1';
          schedule();
        }, 350);
      }, 3500);
    }
    function refresh() {
      if (mq) {
        var paused = !active();
        mq.classList.toggle('dn-motion-paused', paused);
        mq.classList.toggle('dn-motion-static', !!mState.reduced);
      }
      schedule();
    }
    /* arrows: restart the timer after a manual page (otherwise the next auto step fights the manual one) */
    root.addEventListener('click', function (e) {
      var d = e.target.closest('[data-dn5s-ann-step]');
      if (!d) return;
      e.preventDefault(); e.stopPropagation();
      write(i + parseInt(d.getAttribute('data-dn5s-ann-step'), 10));
      schedule();
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var last = es[es.length - 1];
        inView = !!(last && last.isIntersecting && last.intersectionRatio > 0);
        refresh();
      }, { threshold: [0, 0.01] }).observe(root);
    }
    if (motion) {
      motion.subscribe(function (next) { mState = next; refresh(); });
    } else {
      var mm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
      var fb = function () {
        var pop = $('[data-dn-pop]');
        var reduced = !!(mm && mm.matches);
        var covered = !!(pop && !pop.hidden && pop.classList.contains('is-open'));
        mState = { reduced: reduced, popupCovered: covered,
          active: D.visibilityState === 'visible' && !reduced && !covered };
        refresh();
      };
      D.addEventListener('visibilitychange', fb);
      if (mm && mm.addEventListener) mm.addEventListener('change', fb);
    }
    D.addEventListener('shopify:section:unload', function (ev) {
      if (ev.target === root || (ev.target.contains && ev.target.contains(root))) { dead = true; clear(); }
    });
    refresh();
  }

  /* ── 3 · bag item count ────────────────────────────────────────────────── */
  /* The engine's CartDrawer.render() writes textContent + inline display on every [data-cart-count].
     The proto wants it "shown at 0, grey" → display is held by CSS !important; this only handles colours and the
     "N items" copy. Read-only on the cart, never sends cart:refresh. */
  function initBagCount() {
    var badges = $$('[data-cart-count]');
    var labels = $$('[data-dn5s-bag-label]');
    var C = json('[data-dn5s-cart-copy]') || {};
    var tier = $('[data-dn5s-tier]');
    var tierRow = $('[data-dn5s-tier-row]');
    function t(tpl, n) { return String(tpl || '').replace(/\{n\}/g, n); }
    if (!badges.length) return;
    function sync() {
      var n = parseInt((badges[0].textContent || '0').replace(/\D+/g, ''), 10) || 0;
      badges.forEach(function (b) { b.classList.toggle('is-zero', n === 0); });
      labels.forEach(function (l) {
        l.textContent = n === 1 ? (C.itemOne || '') : t(C.itemMany, n);
      });
      if (tier) {
        /* only merchant text from the header settings; empty = hide the whole row */
        var tt = n === 0 ? (C.tier0 || '') : n === 1 ? (C.tier1 || '') : n === 2 ? (C.tier2 || '') : t(C.tier3 || '', n);
        /* {pct_2} / {pct_3} = engine bundle percentages (window.dn.bundle.text, ENGINE-CONTRACT §6.7); unresolvable = hide the row */
        var B = window.dn && window.dn.bundle;
        tt = B ? (B.text(tt, '') || '') : (/\{pct(_\d+|_max)?\}/.test(tt) ? '' : tt);
        tier.textContent = tt;
        if (tierRow) tierRow.hidden = !tt;
      }
    }
    try {
      new MutationObserver(sync).observe(badges[0], { childList: true, characterData: true, subtree: true });
    } catch (e) {}
    D.addEventListener('cart:refresh', function () { setTimeout(sync, 400); });
    sync();
  }

  /* ── 3b · configurable cart drawer copy ────────────────────────────────── */
  /* The drawer is a snippet rendered directly by the layout and snippets cannot carry a schema → the copy lives on the header
     section, which emits it as JSON ([data-dn5s-cart-copy]); it is filled in here.
     The markup already carries the same defaults in Liquid, so nothing flickers when the settings are unchanged
     (the bundle hint row is the exception: it starts empty and hidden and is filled from the settings only). */
  function initCartCopy() {
    var C = json('[data-dn5s-cart-copy]');
    if (!C) return;
    var put = function (sel, val) { var e = $(sel); if (e && val) e.textContent = val; };
    /* every [data-dn5s-copy="key"] (also inside the drawer line <template>) takes its words from the header section settings */
    var fill = function (root) { $$('[data-dn5s-copy]', root).forEach(function (el) { var v = C[el.getAttribute('data-dn5s-copy')]; if (v != null && el.textContent !== v) el.textContent = v; }); };
    fill(D);
    var lt = D.getElementById('cart-line-tpl'); if (lt && lt.content) fill(lt.content);
    put('[data-dn5s-cart-title]', C.title);
    put('[data-dn5s-recs-title]', C.recsTitle);
    put('[data-dn5s-recs-note]', C.recsNote);
    put('[data-dn5s-empty-text]', C.emptyText);
    put('[data-dn5s-empty-cta]', C.emptyCta);
    var link = $('[data-dn5s-bundle-link]');
    if (link) { if (C.bundle) link.textContent = C.bundle; if (C.bundleUrl) link.href = C.bundleUrl; }
    var img = $('[data-dn5s-empty-img]');
    if (img && C.emptyImg) { img.src = C.emptyImg; img.hidden = false; }

    /* footer "Price breakdown ▾": open/close the grid row (dn4 drawer template toggleBreak). Pure display, no amounts touched. */
    var bt = $('[data-dn5s-break-toggle]'), bx = $('[data-dn5s-break]');
    if (bt && bx) {
      var flip = function () { var on = !bx.classList.contains('is-open'); bx.classList.toggle('is-open', on); bt.classList.toggle('is-open', on); bt.setAttribute('aria-expanded', on ? 'true' : 'false'); };
      bt.addEventListener('click', flip);
      bt.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(); } });
    }

    /* 7-7: gift lines (engine marks the row data-cart-gift) show the copy "FREE" in the {price} slot, as the proto/dn4 do.
       Only the label text is swapped; the engine-formatted compare price stays; nothing is calculated here. */
    var items = D.getElementById('cart-drawer-items');
    if (items) {
      var mark = function () {
        fill(items);   /* rows the engine built before this ran also get their words */
        if (C.giftPrice) $$('.cart-item[data-cart-gift] .cart-item__price', items).forEach(function (el) { if (el.textContent !== C.giftPrice) el.textContent = C.giftPrice; });
      };
      try { new MutationObserver(mark).observe(items, { childList: true, subtree: true, characterData: true }); } catch (e) {}
      mark();
    }
  }

  /* ── 4 · region / currency panel ───────────────────────────────────────── */
  /* Data comes from Liquid (localization.available_languages / available_countries).
     Apply = fill [data-loc-form-country]/[data-loc-form-locale] then form.submit()
     — the same submit path as the engine, word for word; this is the hard gate for the free-shipping threshold conversion. */
  function initLoc() {
    var sheet = $('#dn5s-loc');
    var data = json('[data-dn5s-loc-data]');
    if (!sheet || !data || !data.langs || !data.langs.length) return;

    var LANGS = data.langs;                        /* [{iso,code,label,def}] */
    /* 🔴 One row per country, no de-duplication by currency.
       The proto locRows is simply countries.map (line 947), and de-duplication bites:
       duniii's Australia market also uses USD, so after de-dup the "USD" representative becomes Australia,
       and a US visitor who picks USD and applies is moved to the Australian market (the engine's old code had this trap).
       The submitted country_code is always the country the shopper clicked — the plainest rule. */
    var CTS = (data.countries || []).slice();
    var C = json('[data-dn5s-cart-copy]') || {};   /* row notes come from the header section settings */
    if (!CTS.length) CTS = [{ cc: data.country, country: data.country, code: data.currency, sym: '', name: data.currency }];
    /* Header setting loc_show_language off: Liquid drops the tab row; apply shows only the currency and
       submits the CURRENT locale_code, so a visitor on /fr-eu/ stays French. Missing key = shown (old behaviour). */
    var showLang = data.showLang !== false;

    var st = {
      tab: 0,
      L: Math.max(0, LANGS.findIndex(function (l) { return String(l.iso).toLowerCase() === String(data.lang).toLowerCase(); })),
      C: Math.max(0, CTS.findIndex(function (c) { return c.cc === data.country; }))
    };
    var list = $('[data-dn5s-loc-list]', sheet);
    var apply = $('[data-dn5s-loc-apply]', sheet);

    function render() {
      $$('[data-dn5s-loc-tab]', sheet).forEach(function (t) {
        t.classList.toggle('is-on', +t.getAttribute('data-dn5s-loc-tab') === st.tab);
      });
      var isCt = st.tab === 0;
      var src = isCt ? CTS : LANGS;
      var sel = isCt ? st.C : st.L;
      list.innerHTML = src.map(function (it, i) {
        var code = isCt ? it.cc : it.code;
        var name = isCt ? it.country : it.label;
        var sub = isCt ? (it.code + ' ' + it.sym) : ((it.def ? C.locDefault : C.locTranslated) || '');
        return '<button type="button" class="dn5s-lrow' + (i === sel ? ' is-on' : '') +
          '" data-dn5s-loc-row="' + i + '">' +
          '<span class="dn5s-lrow__code">' + esc(code) + '</span>' +
          '<span class="dn5s-lrow__mid"><span class="dn5s-lrow__n">' + esc(name) + '</span>' +
          '<span class="dn5s-lrow__s">' + esc(sub) + '</span></span>' +
          '<span class="dn5s-lrow__r"><i></i></span></button>';
      }).join('');
      if (apply) apply.textContent = (apply.getAttribute('data-label') || '') + ' · ' + CTS[st.C].code + (showLang ? ' · ' + LANGS[st.L].label : '');
      var cur = list.querySelector('.dn5s-lrow.is-on');
      if (cur && cur.scrollIntoView) { try { cur.scrollIntoView({ block: 'nearest' }); } catch (e) {} }
    }

    sheet.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-dn5s-loc-tab]');
      if (tab) { st.tab = +tab.getAttribute('data-dn5s-loc-tab'); render(); return; }
      var row = e.target.closest('[data-dn5s-loc-row]');
      if (row) {
        var i = +row.getAttribute('data-dn5s-loc-row');
        if (st.tab === 0) st.C = i; else st.L = i;
        render();
        return;
      }
      if (e.target.closest('[data-dn5s-loc-apply]')) {
        var form = $('[data-loc-form]', sheet) || $('form.shopify-localization-form', sheet) || $('form', sheet);
        if (!form) return;
        $('[data-loc-form-country]', form).value = CTS[st.C].cc;
        $('[data-loc-form-locale]', form).value = showLang ? LANGS[st.L].iso : data.lang;
        form.submit();
      }
    });
    render();
  }

  /* ── 5 · search ────────────────────────────────────────────────────────── */
  /* Shopify Predictive Search, debounce 200ms — same endpoint and parameters as the engine. */
  function initSearch() {
    var sheet = $('#dn5s-search');
    if (!sheet) return;
    var input = $('[data-dn5s-q]', sheet);
    var rows = $('[data-dn5s-rows]', sheet);
    var label = $('[data-dn5s-rlabel]', sheet);
    var none = $('[data-dn5s-none]', sheet);
    var allWrap = $('[data-dn5s-seeall-wrap]', sheet);
    var all = $('[data-dn5s-seeall]', sheet);
    var defaultRows = null, t = null, lastQ = '';
    var C = json('[data-dn5s-cart-copy]') || {};   /* labels come from the header section settings ({n} = result count) */
    function tpl(s, n) { return String(s || '').replace(/\{n\}/g, n); }
    if (!input || !rows) return;

    function row(r) {
      return '<div class="dn5s-srow" data-dn5s-srow data-handle="' + esc(r.handle) + '">' +
        '<a class="dn5s-srow__img" href="' + ROOT() + 'products/' + esc(r.handle) + '" aria-label="' + esc(r.title) + '"' +
          (r.image ? ' style="background-image:url(\'' + esc(r.image) + '\')"' : '') + '></a>' +
        '<a class="dn5s-srow__mid" href="' + ROOT() + 'products/' + esc(r.handle) + '">' +
          '<span class="dn5s-srow__n">' + esc(r.title) + '</span>' +
          '<span class="dn5s-srow__p"><b>' + esc(r.price) + '</b>' +
          (r.compare ? '<s>' + esc(r.compare) + '</s>' : '') + '</span></a>' +
        '<button type="button" class="dn5s-srow__go" data-dn5s-srow-add="' + esc(r.handle) +
          '" aria-label="' + esc((C.a11y_quick_view ? C.a11y_quick_view + ' ' : '') + r.title) + '">+</button></div>';
    }
    function mode(q, n) {
      if (none) none.style.display = (q && !n) ? '' : 'none';
      if (allWrap) allWrap.style.display = (q && n) ? '' : 'none';
      if (all && q && n) all.textContent = tpl(C.searchSeeall, n);
      if (label) label.textContent = q ? tpl(C.searchResults, n) : (C.searchPopular || '');
    }
    function search(q) {
      lastQ = q;
      if (!q.trim()) {
        if (defaultRows !== null) rows.innerHTML = defaultRows;
        mode('', 0);
        return;
      }
      fetch(ROOT() + 'search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (q !== lastQ) return;
          var ps = (d && d.resources && d.resources.results && d.resources.results.products) || [];
          var hits = ps.map(function (p) {
            var cmp = p.compare_at_price_max && parseFloat(p.compare_at_price_max) > parseFloat(p.price)
              ? p.compare_at_price_max : '';
            return {
              handle: p.handle, title: p.title,
              image: (p.featured_image && (p.featured_image.url || p.image)) || p.image || '',
              /* suggest.json price is already the current market's presentment price; just prefix the currency symbol */
              price: money(p.price), compare: cmp ? money(cmp) : ''
            };
          });
          if (hits.length) rows.innerHTML = hits.map(row).join('');
          mode(q, hits.length);
        })
        .catch(function () {});
    }
    function money(v) {
      var s = String(v == null ? '' : v).trim();
      if (!s) return '';
      if (/^[^\d]/.test(s)) return s;               /* already has a symbol */
      var f = (window.theme && window.theme.moneyFormat) || '';
      if (!f) return s;
      if (/amount_with_comma_separator/.test(f)) s = s.replace('.', ',');   /* format only (e.g. €23,95 like Liquid money) */
      return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s).replace(/<[^>]*>/g, '');
    }

    /* Enter = the same destination as "See all" (/search?q=…, SHELL-CONTRACT §3.3) */
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && input.value.trim()) { e.preventDefault(); window.location.href = ROOT() + 'search?q=' + encodeURIComponent(input.value.trim()); }
    });
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = this.value;
      t = setTimeout(function () { search(q); }, 200);
    });
    sheet.addEventListener('click', function (e) {
      var tag = e.target.closest('[data-dn5s-chip]');
      if (tag) { input.value = tag.getAttribute('data-dn5s-chip'); search(input.value); input.focus(); return; }
      var add = e.target.closest('[data-dn5s-srow-add]');
      if (add) {
        /* "+" = open Quick View to pick colour and size (engine quickShop); never adds to cart past the variant choice */
        var h = add.getAttribute('data-dn5s-srow-add');
        closeSheet(sheet);
        setTimeout(function () {
          if (window.DN2 && window.DN2.quickShop) window.DN2.quickShop.open(h, [h], 0);
          else window.location.href = ROOT() + 'products/' + encodeURIComponent(h);
        }, 80);
        return;
      }
      if (e.target.closest('[data-dn5s-seeall]')) {
        window.location.href = ROOT() + 'search?q=' + encodeURIComponent(input.value);
      }
    });
    sheet.addEventListener('dn2:open', function () {
      if (defaultRows === null) defaultRows = rows.innerHTML;
      input.value = ''; search('');
    });
  }

  /* ── 6 · Quick View skin patch ─────────────────────────────────────────── */
  /* Engine logic is untouched and no engine node is edited; the one intrusion is ③, which inserts our own link node into the
     engine-built SIZE title row (re-inserted after each engine re-render). Only two things the proto wants and the engine cannot give:
     ① map the add-to-cart label to the header-settings wording (the engine writes 'Add to Cart — $x' / 'Added ✓';
        the patterns below only recognise the engine's states, every word shown comes from the settings; empty setting = engine wording)
     ② the "Size guide" link (proto line 406 / dn4 quick template): our own node, re-attached to the right of the SIZE title row
        after every engine render of the options; no size option = it stays parked (hidden), as dn4 only draws it when hasSizes
     All writes are on our own nodes (② places one of them inside the engine row); engine logic is untouched. */
  var ATC_MAP = [                                   /* [engine state, settings key]; {price} = what the engine wrote after the dash */
    [/^Add to Cart\s*[—–-]\s*(.*)$/i, 'qv_atc_add'],
    [/^Added\s*✓$/i, 'qv_atc_added'],
    [/^Adding…$/i, 'qv_atc_adding'],
    [/^Sold out$/i, 'qv_atc_soldout'],
    [/^Unavailable$/i, 'qv_atc_unavailable'],
    [/^Try again$/i, 'qv_atc_retry']
  ];
  /* option title wording (COLOUR / SIZE, proto + dn4) from the header settings, declared for the engine as data-opt-labels on the
     quick view sheet and the bag line template (ENGINE-CONTRACT §6.3 / §6.6); empty settings are left out = product's own name */
  function initOptLabels() {
    var C = json('[data-dn5s-cart-copy]') || {}, L = C.optLabels || {}, map = {};
    Object.keys(L).forEach(function (k) { if (L[k]) map[k] = L[k]; });
    if (!Object.keys(map).length) return;
    var v = JSON.stringify(map);
    ['#dn2-quick-shop', '#cart-line-tpl'].forEach(function (s) { var e = $(s); if (e) e.setAttribute('data-opt-labels', v); });
  }

  function initQuickShop() {
    var sheet = $('#dn2-quick-shop');
    if (!sheet) return;
    var atc = $('[data-qs-atc]', sheet);
    var C = json('[data-dn5s-cart-copy]') || {};

    /* stage takes the photo's own proportions (dn4 quick template: aspect-ratio = image ratio) */
    var stage = $('[data-qs-stage]', sheet), simg = $('[data-qs-img]', sheet);
    if (stage && simg) {
      var fit = function () { if (simg.naturalWidth && simg.naturalHeight) stage.style.aspectRatio = simg.naturalWidth + ' / ' + simg.naturalHeight; };
      simg.addEventListener('load', fit); fit();
    }
    /* eyebrow "QUICK VIEW · N COLOURS" (dn4 / proto): N = colour swatches the engine rendered; suffix text from header settings */
    var ncol = $('[data-dn5s-qs-ncol]', sheet), opts = $('[data-qs-options]', sheet);
    if (ncol && opts) {
      var count = function () {
        /* with the colour template (ENGINE-CONTRACT §6.6) the engine reports the colour count on the sheet */
        var n = parseInt(sheet.getAttribute('data-qv-total') || '', 10) || $$('.dn2-qs__dot', opts).length;
        var t = n && C.qvColours ? n + ' ' + C.qvColours : '';
        if (ncol.textContent !== t) ncol.textContent = t;
      };
      try { new MutationObserver(count).observe(opts, { childList: true, subtree: true }); } catch (e) {}
      try { new MutationObserver(count).observe(sheet, { attributes: true, attributeFilter: ['data-qv-total'] }); } catch (e) {}
      count();
    }

    /* colour hook data (ENGINE-CONTRACT §6.6): the engine writes data-qv-* on the sheet, the skin only places it —
       the colour chip on the photo, the "−N%" tag after the compare-at price and "{a} of {n} in stock" at the right end of
       the colour title row (dn4 quick template). Wording from the header settings; empty setting = not shown. */
    var cchip = $('[data-dn5s-qs-cchip]', sheet), cdot = $('[data-dn5s-qs-cdot]', sheet), cname = $('[data-dn5s-qs-cname]', sheet);
    var offTag = $('[data-dn5s-qs-off]', sheet), stock = D.createElement('span');
    stock.className = 'dn5s-qs__stock';
    var placeStock = function () {
      var row = opts && opts.querySelector('[data-qv-colors]');
      var head = row && row.parentElement ? row.parentElement.previousElementSibling : null;
      if (head && head.tagName === 'SPAN' && stock.textContent) { if (stock.parentNode !== head) head.insertBefore(stock, head.firstChild); }
      else if (stock.parentNode) stock.parentNode.removeChild(stock);
    };
    var qvData = function () {
      var col = sheet.getAttribute('data-qv-color') || '', img = sheet.getAttribute('data-qv-color-img') || '';
      if (cchip) {
        cchip.hidden = !col;
        if (cname) cname.textContent = col;
        if (cdot) cdot.style.background = img ? 'url("' + img.replace(/"/g, '%22') + '") center/cover no-repeat' : '';
      }
      var off = sheet.getAttribute('data-qv-off') || '';
      if (offTag) { var ot = off && C.qv_off ? String(C.qv_off).replace(/\{off\}/g, off) : ''; offTag.textContent = ot; offTag.hidden = !ot; }
      var a = sheet.getAttribute('data-qv-avail') || '', n = sheet.getAttribute('data-qv-total') || '';
      stock.textContent = a && n && C.qv_stock ? String(C.qv_stock).replace(/\{a\}/g, a).replace(/\{n\}/g, n) : '';
      placeStock();
    };
    try { new MutationObserver(qvData).observe(sheet, { attributes: true, attributeFilter: ['data-qv-color', 'data-qv-color-img', 'data-qv-off', 'data-qv-avail', 'data-qv-total'] }); } catch (e) {}
    if (opts) { try { new MutationObserver(placeStock).observe(opts, { childList: true }); } catch (e) {} }
    qvData();

    var guide = $('.dn5s-qs__guide', sheet), park = $('.dn5s-qs__sizehead', sheet);
    if (guide && park && opts) {
      var headName = function (h) { for (var k = 0; k < h.childNodes.length; k++) { if (h.childNodes[k].nodeType === 3) return h.childNodes[k].nodeValue || ''; } return ''; };
      var placeGuide = function () {
        var pick = null;
        Array.prototype.forEach.call(opts.children, function (h) {
          if (h.tagName !== 'SPAN') return;
          var row = h.nextElementSibling;
          if (!row || !row.querySelector('.dn2-qs__chip')) return;          /* colour rows are dots, size rows are chips */
          if (!pick || /size/i.test(headName(h))) pick = h;
        });
        if (pick) { if (guide.parentNode !== pick) pick.insertBefore(guide, pick.firstChild); }
        else if (guide.parentNode !== park) park.appendChild(guide);
      };
      try { new MutationObserver(placeGuide).observe(opts, { childList: true }); } catch (e) {}
      placeGuide();
    }

    if (!atc) return;
    var busy = false;
    function relabel() {
      if (busy) return;
      var txt = (atc.textContent || '').trim();
      if (!txt) return;
      for (var i = 0; i < ATC_MAP.length; i++) {
        var hit = txt.match(ATC_MAP[i][0]);
        if (hit) {
          var w = C[ATC_MAP[i][1]];
          var next = w ? String(w).replace(/\{price\}/g, hit[1] || '') : txt;
          if (next !== txt) { busy = true; atc.textContent = next; busy = false; }
          break;
        }
      }
      /* gold "added" state: the engine's Added ✓, or the configured added wording that replaced it */
      var now = (atc.textContent || '').trim();
      atc.classList.toggle('dn5s-done', ATC_MAP[1][0].test(now) || (!!C.qv_atc_added && now === String(C.qv_atc_added).trim()));
    }
    try {
      new MutationObserver(relabel).observe(atc, { childList: true, characterData: true, subtree: true });
    } catch (e) {}
    relabel();
  }

  /* ── 7 · footer accordions ─────────────────────────────────────────────── */
  /* Phone accordions are native <details> (.dn5s-ft__acc); desktop renders plain columns (.dn5s-ft__cols--d). Nothing to wire. */

  function boot() {
    initTriggers();
    initAnnouncement();
    initBagCount();
    initCartCopy();
    initLoc();
    initSearch();
    initOptLabels();
    initQuickShop();
  }

  window.DN5Shell = { boot: boot, open: openSheet, close: closeSheet, closeAll: closeAll };
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
